/*global VeloxWebView, VeloxDatabaseClient, VeloxServiceClient*/

var uuid = require("uuid") ;
var sync = require("./sync") ;

var checkConnectedId = null;
/**
 * Called on login or refresh
 */
module.exports = function(api, callback){
    checkConnectedId = setInterval(function(){
        api.refreshUser(function(err){
            if(err){
                if(checkConnectedId){
                    clearInterval(checkConnectedId) ;
                }
            }
        });
    }, 1000*60*60) ;
    if(api.currentUser.realms.length === 1 && api.currentUser.profile_code === "NORMAL"){
        //don't autosync before check reseller options
        VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_MANUAL) ;
        api.api.reseller.searchFirst({r_code : api.currentUser.realms[0].realm.code}, function(err, resellerLocal){
            if(err){
                resellerLocal = {r_lang: "fr-FR"} ;
            }
            if(resellerLocal && resellerLocal.r_nosync){
                //no sync, remove offline changes
                localStorage.setItem(api.currentUser.login+"_velox_offline_changes", "[]") ;
            }
            VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_ALWAYS) ;
            api.api.multiread({
                reseller_settings: {searchFirst : {r_code : api.currentUser.realms[0].realm.code}},
                reseller: {searchFirst : {r_code : api.currentUser.realms[0].realm.code}},
            }, function(err, reads){
                var reseller;
                if(err){
                    reseller = {r_lang: "fr-FR"} ;
                }
                reseller = reads.reseller;
                VeloxWebView.i18n.setLang(reseller.r_lang) ;
                var phoneCountry = reseller.r_lang.substring(0,2).toUpperCase();
                if(phoneCountry === "EN"){
                    phoneCountry = "GB" ;
                }
                VeloxWebView.fields.setPhoneCountry(phoneCountry) ;
                VeloxWebView.country.setOptions({country: reseller.r_lang.substring(0,2).toUpperCase()}) ;
                if(reseller.r_nosync){
                    //no sync, put the sync strategy to read only
                    VeloxDatabaseClient.setSyncStrategy(sync.SYNC_STRATEGY_READONLY) ;
                    if(VeloxServiceClient.setSyncBinaryAuto){
                        VeloxServiceClient.setSyncBinaryAuto(false) ;
                    }
                    //force sync to be only on reseller
                    var realSync =api.api.sync ;
                    api.api.sync = function(){
                        realSync.call(api.api, ["reseller", "reseller_settings"], arguments[arguments.length-1]) ;
                    } ;
                    if(window.native && window.native.backupOffline){
                        api.api.backup(function(err, dbString){
                            if(err){ return callback(err) ;}
                            window.native.backupOffline.backupData({dbString: dbString}, function(err, filename){
                                if(err){ return console.log("error when auto backup", err) ;}
                                console.log("auto backup done "+filename) ;
                                
                                
                            }) ;
                        }) ;
                    }
                }else{
                    //normal sync
                    VeloxDatabaseClient.setSyncStrategy(VeloxDatabaseClient.SYNC_STRATEGY_ALWAYS) ;
                }
                if(resellerLocal && resellerLocal.r_nosync && !reseller.r_nosync){
                    //change from nosync to sync
                    sync.resyncAll(api, function(){
                        migrateData(api, reseller, callback) ;
                    }) ;
                }else{
                    if(!reseller.r_nosync){
                        doFullSync(api) ;
                    }
                    migrateData(api, reseller, callback) ;
                }
            }.bind(this)) ;
        }.bind(this)) ;
    }else if(api.currentUser.lang){
        VeloxWebView.i18n.setLang(api.currentUser.lang) ;
        callback() ;
    }else{
        callback() ;
    }
} ;

function migrateData(api, reseller,  callback){
    return callback() ;
}


var fullSyncDone = false;

function doFullSync(api){
    if(!fullSyncDone && api.currentUser && api.currentUser.login !== "anonymous"){ 
        fullSyncDone = true ;
        if(window.native){
            console.log("binary sync") ;
            api.syncBinary(function(err){
                if(err){
                    console.log("binary sync failed", err) ;
                    fullSyncDone = false;
                }
            }) ;
        }
        console.log("database sync") ;
        api.api.sync(function(err){
            if(err){
                console.log("database sync failed", err) ;
                fullSyncDone = false;
            }
        }) ;
    } 
}